<template>
  <div class="swaychat-notification swaychat-bounceIn"
    @click="toggleMinimize"
    :style="{
      'border-color': getPrimaryBg
    }" :class="{
      'swaychat-zoomOut': hide
    }">
    <p>{{ message }}<span>{{ getLang.sent }} {{ sent }}</span></p>
    <button type="button" class="swaychat-notification-close swaychat-button-close" @click.prevent="close($event)">×</button>
    <audio ref="blop">
      <source src="//@@CDN/assets/sounds/blop.mp3" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  mounted() {
    if (!this.isMute) {
      var promise = this.$refs.blop.play();

      if (promise !== undefined) {
        promise.then(_ => {
          // Autoplay started!
        }).catch(error => {
          // Autoplay was prevented.
        });
      }
    }
  },
  props: [
    'message',
    'sent',
    'hide'
  ],
  computed: {
    ...mapGetters([
      'getLang',
      'getPrimaryBg',
      'isMute'
    ])
  },
  methods: {
    close(e) {
      e.stopPropagation()
      this.$emit('close')
    },
    toggleMinimize() {
      this.$emit('click')
    }
  }
}

</script>
